export const SEND_CHAT_MESSAGE = `chatMessages/SEND_CHAT_MESSAGE`
export const CHAT_MESSAGE_SENT = `chatMessages/CHAT_MESSAGE_SENT`
export const CHAT_MESSAGE_UPDATED = `chatMessages/CHAT_MESSAGE_UPDATED`
